import { Link } from "react-router-dom";
import "./noAuthFooter.scss";

interface NoAuthFooterProps {
  extraClasses?: string;
}

const NoAuthFooter = ({ extraClasses = "" }: NoAuthFooterProps) => {
  return (
    <div className={`footer-links ${extraClasses}`}>
      <Link
        to="/terms-and-conditions"
        className="text-decoration-underline"
        target="blank"
        onMouseDown={(e) => e.preventDefault()}
      >
        Terms & Conditions
      </Link>
      <Link
        to="/support"
        className="text-decoration-underline"
        target="blank"
        onMouseDown={(e) => e.preventDefault()}
      >
        Support
      </Link>
      <Link
        to="/customer-care"
        className="text-decoration-underline"
        target="blank"
        onMouseDown={(e) => e.preventDefault()}
      >
        Customer Care
      </Link>
    </div>
  );
};

export default NoAuthFooter;
